import React from 'react';
import { useDialog } from '../components/DialogContext';

/**
 * DIALOG TEST PAGE
 * Add this route to test all dialogs:
 * <Route path="/dialog-test" element={<DialogTest />} />
 */
function DialogTest() {
  const dialog = useDialog();

  const testLogout = async () => {
    const confirmed = await dialog.confirmLogout({
      message: 'Are you sure you want to logout?'
    });
    alert(confirmed ? 'User confirmed logout' : 'User cancelled');
  };

  const testDelete = async () => {
    const confirmed = await dialog.confirmDelete({
      title: 'Delete Item',
      message: 'This action cannot be undone. Are you sure?'
    });
    alert(confirmed ? 'User confirmed delete' : 'User cancelled');
  };

  const testConfirm = async () => {
    const confirmed = await dialog.confirm({
      title: 'Confirm Action',
      message: 'Do you want to proceed with this action?',
      confirmText: 'Yes, proceed',
      cancelText: 'No, cancel'
    });
    alert(confirmed ? 'User confirmed' : 'User cancelled');
  };

  const testSuccess = async () => {
    await dialog.success({
      title: 'Success!',
      message: 'Your changes have been saved successfully.'
    });
  };

  const testError = async () => {
    await dialog.error({
      title: 'Error',
      message: 'Something went wrong. Please try again.'
    });
  };

  const testWarning = async () => {
    const confirmed = await dialog.warning({
      title: 'Warning',
      message: 'This action may have consequences. Continue?',
      confirmText: 'Continue Anyway',
      cancelText: 'Go Back'
    });
    alert(confirmed ? 'User continued' : 'User went back');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '60px 20px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        background: 'white',
        borderRadius: '24px',
        padding: '48px',
        boxShadow: '0 25px 80px rgba(0,0,0,0.2)'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: 'bold',
          background: 'linear-gradient(135deg, #667eea, #764ba2)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          🎨 Beautiful Dialogs Test
        </h1>
        
        <p style={{
          textAlign: 'center',
          color: '#6b7280',
          marginBottom: '48px',
          fontSize: '18px'
        }}>
          Click each button to preview the dialog styles
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '20px'
        }}>
          {/* Logout Dialog */}
          <button
            onClick={testLogout}
            style={{
              padding: '24px',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              color: 'white',
              border: 'none',
              borderRadius: '16px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(102, 126, 234, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            👋 Logout Dialog
            <div style={{ fontSize: '14px', opacity: 0.9, marginTop: '8px' }}>
              Purple gradient
            </div>
          </button>

          {/* Delete Dialog */}
          <button
            onClick={testDelete}
            style={{
              padding: '24px',
              background: 'linear-gradient(135deg, #ef4444, #dc2626)',
              color: 'white',
              border: 'none',
              borderRadius: '16px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(239, 68, 68, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            ⚠️ Delete Dialog
            <div style={{ fontSize: '14px', opacity: 0.9, marginTop: '8px' }}>
              Red warning
            </div>
          </button>

          {/* Confirm Dialog */}
          <button
            onClick={testConfirm}
            style={{
              padding: '24px',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              color: 'white',
              border: 'none',
              borderRadius: '16px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(102, 126, 234, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            ❓ Confirm Dialog
            <div style={{ fontSize: '14px', opacity: 0.9, marginTop: '8px' }}>
              General confirm
            </div>
          </button>

          {/* Success Dialog */}
          <button
            onClick={testSuccess}
            style={{
              padding: '24px',
              background: 'linear-gradient(135deg, #10b981, #059669)',
              color: 'white',
              border: 'none',
              borderRadius: '16px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(16, 185, 129, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            ✅ Success Dialog
            <div style={{ fontSize: '14px', opacity: 0.9, marginTop: '8px' }}>
              Green gradient
            </div>
          </button>

          {/* Error Dialog */}
          <button
            onClick={testError}
            style={{
              padding: '24px',
              background: 'linear-gradient(135deg, #ef4444, #dc2626)',
              color: 'white',
              border: 'none',
              borderRadius: '16px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(239, 68, 68, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            ⚠️ Error Dialog
            <div style={{ fontSize: '14px', opacity: 0.9, marginTop: '8px' }}>
              Error message
            </div>
          </button>

          {/* Warning Dialog */}
          <button
            onClick={testWarning}
            style={{
              padding: '24px',
              background: 'linear-gradient(135deg, #f59e0b, #d97706)',
              color: 'white',
              border: 'none',
              borderRadius: '16px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(245, 158, 11, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            ⚠️ Warning Dialog
            <div style={{ fontSize: '14px', opacity: 0.9, marginTop: '8px' }}>
              Orange warning
            </div>
          </button>
        </div>

        <div style={{
          marginTop: '48px',
          padding: '24px',
          background: '#f3f4f6',
          borderRadius: '16px',
          border: '2px solid #e5e7eb'
        }}>
          <h3 style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#1f2937',
            marginBottom: '16px'
          }}>
            ✨ Implementation Notes:
          </h3>
          <ul style={{
            color: '#4b5563',
            lineHeight: '1.8',
            paddingLeft: '24px'
          }}>
            <li>All dialogs have smooth animations</li>
            <li>Icons pulse to draw attention</li>
            <li>Backdrop blur for modern feel</li>
            <li>Hover effects on all buttons</li>
            <li>Mobile responsive design</li>
            <li>Fully customizable text & colors</li>
          </ul>
        </div>

        <div style={{
          marginTop: '24px',
          textAlign: 'center',
          padding: '20px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '12px',
          color: 'white'
        }}>
          <p style={{ fontSize: '16px', fontWeight: '600' }}>
            🎉 Replace all window.confirm() and alert() with these beautiful dialogs!
          </p>
        </div>
      </div>
    </div>
  );
}

export default DialogTest;
